import type { ReactNode } from 'react';

interface HighlightedTranslationOptions {
  text: string;
  tagName: 'span' | 'strong';
  className: string;
}

/**
 * Renders trusted translation markup as React nodes instead of injecting HTML.
 */
export function renderHighlightedTranslation({
  text,
  tagName,
  className,
}: HighlightedTranslationOptions): ReactNode {
  const openingTag = `<${tagName}>`;
  const closingTag = `</${tagName}>`;
  const openingIndex = text.indexOf(openingTag);
  const closingIndex = text.indexOf(closingTag);

  if (openingIndex === -1 || closingIndex === -1 || closingIndex <= openingIndex) {
    return text;
  }

  const before = text.slice(0, openingIndex);
  const highlighted = text.slice(openingIndex + openingTag.length, closingIndex);
  const after = text.slice(closingIndex + closingTag.length);
  const HighlightTag = tagName;

  return (
    <>
      {before}
      <HighlightTag className={className}>{highlighted}</HighlightTag>
      {after}
    </>
  );
}
